// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"style_wrapper__MuXkF","loader":"style_loader__i3r1U","buttonWrapper":"style_button-wrapper__sWuz2","disabled":"style_disabled__CqVch"};